import React from 'react';
import {
  Button,
  Card,
  CardContent,
  PageLayout,
  TimeSlot,
} from '../../../../components/shared';
import { useLanguage } from '../../../../hooks/shared';
import { useHomeDayDetailMode } from '../../hooks';
import { Training } from '../../types/calendarTypes';
import { EmptyDayState } from '../states';

interface DayDetailViewProps {
  isDayDetail: boolean;
  selectedDate: Date | null | undefined;
  eventInstanceStore: any;
  scheduleStore: any;
  userStore: any;
  format: (date: Date, formatStr: string) => string;
  navigationHandlers: {
    handleTimeSlotClick: (date: string, trainingId: string) => void;
  };
}

/**
 * Smart component for day detail view mode
 */
export const DayDetailView: React.FC<DayDetailViewProps> = ({
  isDayDetail,
  selectedDate,
  eventInstanceStore,
  scheduleStore,
  userStore,
  format,
  navigationHandlers,
}) => {
  const { t } = useLanguage();

  // Use day detail mode hook internally
  const dayDetailData = useHomeDayDetailMode(
    isDayDetail,
    selectedDate,
    eventInstanceStore,
    scheduleStore,
    userStore,
    format
  );

  // If not in day detail mode or no data, don't render
  if (!isDayDetail || !dayDetailData) {
    return null;
  }

  const { schedule, currentSchedule } = dayDetailData;

  const weekday = selectedDate ? format(selectedDate, 'EEEE') : '';
  const weekdayCapitalized = weekday
    ? `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}`
    : '';

  return (
    <PageLayout
      title={selectedDate ? format(selectedDate, 'd MMMM yyyy') : ''}
      subtitle={
        selectedDate
          ? `${weekdayCapitalized}${currentSchedule?.name ? ` • ${currentSchedule.name}` : ''}`
          : ''
      }
      icon="📅"
    >
      <Card className="shadow-xl">
        <CardContent className="p-6">
          {/* Back button */}
          <div className="mb-6">
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              className="flex items-center gap-2"
            >
              <span>←</span>
              {t('common.back')}
            </Button>
          </div>

          {!schedule || schedule.timeSlots.length === 0 ? (
            <EmptyDayState />
          ) : (
            <div className="space-y-4">
              {/* <div className="flex items-center mb-6">
                <Button className="bg-gradient-to-r from-blue-600 to-purple-600">
                  {t('calendar.addTraining')}
                </Button>
              </div> */}
              <div className="grid gap-4">
                {schedule.timeSlots.map((training: Training) => (
                  <TimeSlot
                    key={training.id}
                    training={training}
                    onClick={() =>
                      navigationHandlers.handleTimeSlotClick(
                        schedule.date,
                        training.id
                      )
                    }
                    className={''}
                  />
                ))}
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </PageLayout>
  );
};
